const parseFlag = (value) => {
  if (value === true || value === 1 || value === '1') return true;
  if (value === false || value === 0 || value === '0') return false;
  return null;
};

const parseRemaining = (value) => value !== null && value !== undefined && value !== ''
  && typeof value !== 'boolean' && Number.isFinite(Number(value)) && Number(value) >= 0 ? Number(value) : null;

const parseDate = (value) => typeof value === 'string' && Number.isFinite(Date.parse(value)) ? value : null;

// 新线路兼容数字和布尔 Plus 标记；未返回的负载、智能状态与额度不作推断。
export const convertGptPlusNodes = (data) => {
  if (!Array.isArray(data?.list)) return [];

  return data.list.filter(node => node && node.carID && parseFlag(node.isPlus) === true).map(node => {
    const isOnline = Number(node.status) === 1;
    const color = isOnline && ['green', 'yellow', 'red'].includes(node.color) ? node.color : (isOnline ? null : 'red');
    const count = node.count !== null && node.count !== undefined && node.count !== ''
      && Number.isFinite(Number(node.count)) && Number(node.count) >= 0 ? Number(node.count) : null;

    const metadata = node.metadata && typeof node.metadata === 'object' ? node.metadata : {};
    const limits = Array.isArray(metadata.limits_progress) ? metadata.limits_progress.flatMap(limit => {
      if (!limit || typeof limit.feature_name !== 'string' || !limit.feature_name.trim()) return [];
      const remaining = parseRemaining(limit.remaining);
      const resetAt = parseDate(limit.reset_after);
      return remaining === null && !resetAt ? [] : [{ feature: limit.feature_name.trim(), remaining, resetAt }];
    }) : [];

    return {
      id: node.carID,
      label: String(node.label || 'PLUS').toUpperCase(),
      accountCategory: 'plus',
      isPlusAccount: true,
      isFullPower: parseFlag(node.isIQ),
      status: !isOnline || color === 'red' ? 'maintenance' : 'online',
      color,
      count,
      description: typeof node.desc === 'string' ? node.desc.split('|').filter(Boolean).join(' · ') : '',
      limitDescription: typeof node.limitDesc === 'string' ? node.limitDesc.trim() : '',
      recoverySeconds: Math.max(Number(node.clears_in) || 0, Number(node.team_clears_in) || 0, 0),
      defaultModel: typeof metadata.default_model_slug === 'string' ? metadata.default_model_slug.trim() : '',
      metadataUpdatedAt: parseDate(metadata.updated_at),
      limits,
    };
  }).sort((a, b) => {
    // 可用节点在前，再按负载颜色、满血状态、使用人数排序。
    const ranks = { green: 0, yellow: 1, red: 3 };
    return (Number(b.status === 'online') - Number(a.status === 'online'))
      || ((ranks[a.color] ?? 2) - (ranks[b.color] ?? 2))
      || (Number(b.isFullPower === true) - Number(a.isFullPower === true))
      || ((a.count ?? Infinity) - (b.count ?? Infinity));
  });
};
